import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { buildCatalogPath, getCatalogVendeur, isCatalogPath } from "../../../catalog/catalogTenant";
import CatalogFooterCredit from "../../../catalog/CatalogFooterCredit";
import { FaCartShopping } from "react-icons/fa6";
import { useAppSelector } from "../../../redux/hook";
import { getImage } from "../../../utils/Utils";
import SearchForm from "../FrontHeader/SearchForm";
import defaultAvatar from "../../../assets/images_td/appImages/Avatar.png";

/** Même bleu que le dégradé de la bannière catalogue. */
const CATALOG_BANNER_BLUE = "#0B3D68";

interface TemplateNavbarProps {
  vendeurName?: string;
  showSearch?: boolean;
  /** Détail produit : logo et panier seulement. */
  compact?: boolean;
}

export default function TemplateNavbar({
  vendeurName,
  showSearch = true,
  compact = false,
}: TemplateNavbarProps) {
  const navigate = useNavigate();
  const { cartItems } = useAppSelector((s) => s.cart);
  const cartCount = cartItems?.length ?? 0;
  const catalogVendeur = getCatalogVendeur();
  const isCatalog = isCatalogPath();

  const storeName =
    vendeurName ||
    catalogVendeur?.nom_boutique ||
    catalogVendeur?.nom_de_la_boutique ||
    "Nom de la boutique";

  const avatarSrc = catalogVendeur?.avatar
    ? getImage(catalogVendeur.avatar)
    : defaultAvatar;

  useEffect(() => {
    const previousHtml = document.documentElement.style.backgroundColor;
    document.documentElement.style.backgroundColor = CATALOG_BANNER_BLUE;
    document.body.style.setProperty(
      "background-color",
      CATALOG_BANNER_BLUE,
      "important",
    );

    const metas = document.querySelectorAll('meta[name="theme-color"]');
    if (metas.length === 0) {
      const meta = document.createElement("meta");
      meta.setAttribute("name", "theme-color");
      meta.setAttribute("content", CATALOG_BANNER_BLUE);
      document.head.appendChild(meta);
    } else {
      metas.forEach((node) => {
        const fresh = document.createElement("meta");
        fresh.setAttribute("name", "theme-color");
        fresh.setAttribute("content", CATALOG_BANNER_BLUE);
        const media = node.getAttribute("media");
        if (media) fresh.setAttribute("media", media);
        node.replaceWith(fresh);
      });
    }

    return () => {
      document.documentElement.style.backgroundColor = previousHtml;
      document.body.style.removeProperty("background-color");
    };
  }, []);

  return (
    <nav
      className={`template-navbar${compact ? " template-navbar--compact" : ""}`}
    >
      <button
        type="button"
        className="template-navbar__cart-btn"
        title="Panier"
        onClick={() => navigate(buildCatalogPath("/valider-commande"))}
      >
        <div className="template-navbar__cart-icon-wrapper">
          <FaCartShopping size={compact ? 20 : 26} color="white" />
          {cartCount > 0 && (
            <span className="template-navbar__cart-badge">{cartCount}</span>
          )}
        </div>
      </button>

      <div
        className="template-navbar__logo"
        onClick={() => navigate(buildCatalogPath("/"))}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            navigate(buildCatalogPath("/"));
          }
        }}
        role="button"
        tabIndex={0}
        title="Accueil"
      >
        <img
          src={avatarSrc}
          alt={storeName}
          className="template-navbar__logo-img"
        />
      </div>

      {!compact && (
        <div className="template-navbar__store-name">{storeName}</div>
      )}

      {!compact && showSearch && (
        <SearchForm useTemplateStyle={true} placeholder="Recherchez ici" />
      )}

      {isCatalog && !compact ? <CatalogFooterCredit /> : null}
    </nav>
  );
}
